<!-- <div *ngIf="fill" class="fill-background"></div> -->
<img
  src="/assets/images/AventiBakgrunn_trans.png"
  class="background noselect"
  alt=""
  [style.margin-bottom]="mobileQuery.matches ? '60px' : '0'"
/>
<app-version
  [style.margin-bottom]="mobileQuery.matches ? '60px' : '0'"
  *ngIf="showversion"
  class="noselect"
  style="
    position: fixed;
    right: 0;
    bottom: 0;
    z-index: 10;
"></app-version>
